export default __webpack_public_path__ + "alberta-rehydration.d1aa6c099c377c04fad7.svg";